import React from 'react';
import { viewMap } from '@/views';
import { useGlobalStore } from '@/store';

const percentageMap: Record<keyof typeof viewMap, number | null> = {
  DETAILS: 15,
  DIGILOCKER_SUCCESS: null,
  E_MANDATE_SUCCESS: null,
  EMI_PLANS: 45,
  EMPLOYER_DETAILS: 30,
  LANDING: null,
  PAYMENTS: 90,
  SELFIE_KYC: 60,
};

const ProgressIndicator: React.FC = () => {
  const activeView = useGlobalStore((store) => store.activeView);

  const percentage = percentageMap[activeView];

  return percentage ? (
    <div data-testid="progress-bar" className="mx-6 mt-3 d:hidden">
      <span className="text-neutral-800 text-sm">{percentage}%</span>
      <div className="flex rounded-full bg-surface-grey-subtle">
        <div
          className="bg-surface-positive-subtle h-2 rounded-full"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  ) : null;
};

export default ProgressIndicator;
